app.controller("StudentCardController", ["$scope", "$q", "StSubject", "Users", "AuthService", "StaticData", "$uibModal", "ConfirmModal", "$stateParams", "$state", "toastr","usSpinnerService",
    function ($scope, $q, StSubject, Users, AuthService, StaticData, $uibModal, ConfirmModal, $stateParams, $state, toastr, usSpinnerService) {
        $scope.subjects = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.selections = [];
        $scope.enabled = true;
        $scope.allCredits = 0;

        $scope.changeLevel = function (student) {
            $state.go('.', {profile: student})
        };

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');
        });

        AuthService.getProfiles().then(function (profiles) {
            $scope.profiles = _(profiles).filter({type: 'student'}).value();
            var active = _(profiles).filter({type: 'student', state: 'active'}).head();
            if (!active && profiles.length) {
                $scope.student = $scope.profiles[0];
                return $scope.changeLevel(profiles[0]._id);
            }
            if ($stateParams.profile) $scope.student = $stateParams.profile;
            else if (active) $scope.student = active;
        });

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.toggle = function (val) {
            $scope.enabled = !$scope.enabled
        };

        // $scope.printStudentCard = function () {
        //     window.open('subject/export/' + $scope.student._id);
        // };

        $scope.details = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "DetailsController",
                templateUrl: _pb + 'student/card/details.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    subject: function () {
                        return subject
                    }
                }
            }).result
                .then(function (result) {

                });
        };

        function renderSelections(selections) {
            $scope.allCredits = 0;
            $scope.selections = selections;

            $scope.confessed = _(selections).filter('confessed').value();
            $scope.confessedCredits = _.sumBy($scope.confessed, 'credits');
            $scope.allCredits += $scope.confessedCredits;

            $scope.semesterSubjects = _($scope.selections).filter(function (s) {
                return !s.confessed;
            }).mapValues(function (s) {
                s.semester = s.semester || null;
                return s;
            }).groupBy('semester').mapValues(function (s) {
                return {
                    subjects: s, sum: _(s).filter(function (x) {
                        if (x.credits && x.state === 'passed') $scope.allCredits += x.credits;
                        return x.state === 'passed'
                    }).sumBy('credits'), average: _(s).filter(function (x) {
                        return x.state !== 'current';
                    }).meanBy('score')
                }
            }).value();

            $scope.keys = _.keys($scope.semesterSubjects).reverse();
        }

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            $q.all([StSubject.list({
                page: page,
                limit: $scope.itemsPerPage,
                student: $stateParams.profile
            }), StSubject.totals({student: $stateParams.profile})]).then(function (data) {
                var selections = data[0];
                var totals = data[1];
                $scope.average = totals.average;
                $scope.gpa = totals.gpa;
                renderSelections(selections);
                usSpinnerService.stop("root");
                cb();
            });
        }
    }
]);
